import { toast } from 'react-toastify';

const notify = {
  // Custom success toast
  success: (message: string, options = {}) => {
    return toast.success(message ?? 'Klappat och klart!', {
      autoClose: 2000,
      icon: (
        <svg className="shrink-0 fill-current text-green-500 mt-[3px] mr-3" width="16" height="16" viewBox="0 0 16 16">
          <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zM7 11.4L3.6 8 5 6.6l2 2 4-4L12.4 6 7 11.4z" />
        </svg>
      ),
      className: '!bg-green-100 !rounded-lg !m-2',
      bodyClassName: 'text-sm !text-gray-700 !font-outfit',
      ...options,
    });
  },

  // Custom error toast
  error: (message: string, options = {}) => {
    return toast.error(message ?? 'Något gick fel! Försök igen.', {
      autoClose: 3000,
      icon: (
        <svg className="shrink-0 fill-current text-red-500 mt-[3px] mr-3" width="16" height="16" viewBox="0 0 16 16">
          <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm3.5 10.1l-1.4 1.4L8 9.4l-2.1 2.1-1.4-1.4L6.6 8 4.5 5.9l1.4-1.4L8 6.6l2.1-2.1 1.4 1.4L9.4 8l2.1 2.1z" />
        </svg>
      ),
      className: '!bg-red-100 !rounded-lg !m-2',
      bodyClassName: '!text-sm !text-gray-700 !font-outfit',
      ...options,
    });
  },

  // Custom info toast
  info: (message: string, options = {}) => {
    return toast.info(message, {
      autoClose: 3000,
      icon: (
        <svg className="shrink-0 fill-current text-violet-500 mt-[3px] mr-3" width="16" height="16" viewBox="0 0 16 16">
          <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z" />
        </svg>
      ),
      className: '!bg-violet-100 !rounded-lg !m-2',
      bodyClassName: '!text-sm !text-gray-100 !font-outfit',
      hideProgressBar: true,
      ...options,
    });
  },

  // Custom warning toast
  warn: (message: string, options = {}) => {
    return toast.warn(message, {
      autoClose: 3000,
      icon: (
        <svg className="shrink-0 fill-current text-yellow-500 mt-[3px] mr-3" width="16" height="16" viewBox="0 0 16 16">
          <path d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm0 12c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zm1-3H7V4h2v5z" />
        </svg>
      ),
      className: '!bg-yellow-100 !rounded-lg !m-2',
      bodyClassName: '!text-sm !text-gray-700 !font-outfit',
      ...options,
    });
  },
};

export default notify;
